/**
 * Admin password step-up: re-posts the same body as login
 * (`POST /security/auth` with `{ email, password }`).
 *
 * Email and password must be strings — if either is missing or an object,
 * JSON.stringify drops/mis-shapes the field and security-api answers 400.
 */
export const toLoginCredentials = (email, password) => ({
  email: typeof email === 'string' ? email.trim() : '',
  password: typeof password === 'string' ? password : ''
});

const verifyAdminPassword = (securityModule, email, password) => {
  const credentials = toLoginCredentials(email, password);
  return securityModule.auth(credentials.email, credentials.password);
};

export default verifyAdminPassword;
